import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@shared/validators/no-white-spaces.validator';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AuAutofocusDirective } from '@shared/directives/au-autofocus.directive';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'au-cmms-entity-name',
	templateUrl: './cmms-entity-name.component.html',
	styleUrls: ['./cmms-entity-name.component.scss'],
	imports: [
		CommonModule,
		MatInputModule,
		ReactiveFormsModule,
		AuAutofocusDirective,
		NgxTolgeeModule,
		MatIconModule,
	],
})
export class CmmsEntityNameComponent implements OnInit {
	@Input() set name(entityName) {
		this.formControl.patchValue(entityName);
	}
	@Input() previewValue: string = null;
	@Input() editMode: boolean;
	@Input() disableEdit = false;
	@Input() disablePreview = false;
	@Input() autofocusEnabled = false;
	@Input() namePreviewClasses: string;
	@Input() placeholder = this.translateService.instant('enter_title');

	@Output() inputBlur = new EventEmitter<{ name: string }>();
	@Output() controlReady = new EventEmitter<FormControl>();
	@ViewChild('inputControl', { static: false }) inputControl;

	formControl = new FormControl('', [Validators.required, noWhitespaceValidator()]);

	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
	}

	onBlurHandler() {
		if (this.formControl.valid) {
			if (!this.disablePreview) {
				this.editMode = false;
			}
			this.inputBlur.emit({ name: this.formControl.value });
		}
	}

	previewClickHandler() {
		if (!this.disableEdit) {
			this.editMode = true;
			setTimeout(() => {
				this.inputControl.nativeElement.focus();
			});
		}
	}

	submitKeydown(event: KeyboardEvent) {
		event.preventDefault();
		this.formControl.markAsTouched();
		if (this.formControl.valid) {
			this.inputControl.nativeElement.blur();
		}
	}
}
